import Describer from "../../../utils/issues/issue_description/describer";

function render(issue, topics) {
  const describer = new Describer.IssueDescriber(issue, topics, "or");
  return `Either ${describer.listChildIssues} in any clause`;
}

export default render;
